import React from 'react';
import { Redirect } from 'react-router-dom';

import route from './route';
import { getRoutePermission } from './permissionMap';
import { hasPermission, getDefaultRoute } from '../utils/permissions';
import { withAppBar } from '../components/PrimaryAppBar';

const PrivateRoute = props => {
    const { component, permission, ...rest } = props;
    const [openNavBarMobile, setopenNavBarMobile] = React.useState(false)

    const checkAuth = () => {
        const authLoacal = localStorage.getItem('token');
        if(authLoacal?.length > 0){
            return true;
        }else{
            return false;
        }
    }

    const requiredPermission = permission || getRoutePermission(rest.path);
    const Component = props => withAppBar(component, { ...props, openNavBarMobile, setopenNavBarMobile });

    if (!checkAuth()) {
        return <Redirect to={route.login} />
    }

    if (requiredPermission && !hasPermission(requiredPermission)) {
        return <Redirect to={getDefaultRoute()} />
    }

    return <Component {...rest} />
}


export default PrivateRoute;
